import { ITokenStorage, StoredUser } from '../../application/interfaces/token-storage.interface';

export class LocalStorageTokenStorage implements ITokenStorage {
  private static readonly TOKEN_KEY = 'bartech_access_token';
  private static readonly USER_KEY = 'bartech_user';

  public getToken(): string | null {
    try {
      return localStorage.getItem(LocalStorageTokenStorage.TOKEN_KEY);
    } catch {
      return null;
    }
  }

  public setToken(token: string): void {
    try {
      localStorage.setItem(LocalStorageTokenStorage.TOKEN_KEY, token);
    } catch (e) {
      console.error('Error al guardar el token en localStorage:', e);
    }
  }

  public getUser(): StoredUser | null {
    try {
      const data = localStorage.getItem(LocalStorageTokenStorage.USER_KEY);
      if (!data) return null;
      return JSON.parse(data) as StoredUser;
    } catch {
      return null;
    }
  }

  public setUser(user: StoredUser): void {
    try {
      localStorage.setItem(LocalStorageTokenStorage.USER_KEY, JSON.stringify(user));
    } catch (e) {
      console.error('Error al guardar el usuario en localStorage:', e);
    }
  }

  public clear(): void {
    try {
      localStorage.removeItem(LocalStorageTokenStorage.TOKEN_KEY);
      localStorage.removeItem(LocalStorageTokenStorage.USER_KEY);
    } catch (e) {
      console.error('Error al limpiar sesión en localStorage:', e);
    }
  }
}
